import Button from "../components/Button";
import "../styles/NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <Button>Home</Button>
    </div>
  );
};

export default NotFound;
